export default __webpack_public_path__ + "static/media/personDetail-mobile.b449e156.webp";